import React, { useEffect, useState } from "react";
import { Card } from "reactstrap";
import { useDispatch, useSelector } from "react-redux";
import { useParams, useHistory } from "react-router-dom";
import { toast } from "react-toastify";
import {
  thirdPartyGoogleUrlAuth,
  thirdPartyGoogleGenerateAccessToken,
} from "../../../../store/thirdPartyIntegration/action";
import LoadingSpinner from "../../../../Components/Common/Spinner";
import { isEmpty } from "lodash";

export default function GoogleIntegration() {
  const dispatch = useDispatch();
  const history = useHistory();
  const params = useParams();
  const [extractedCode, setExtractedCode] = useState(null);
  const [accessTokenGenerated, setAccessTokenGenerated] = useState(false);
  const [responseMessage, setResponseMessage] = useState("");

  const {
    thirdPartyGoogleUrlAuthDataAPI,
    thirdPartyGoogleUrlAuthLoading,
    thirdPartyGoogleGenerateAccessTokenDataAPI,
  } = useSelector((state) => ({
    thirdPartyGoogleUrlAuthDataAPI:
      state.ThirdPartyIntegration.thirdPartyGoogleUrlAuthData,
    thirdPartyGoogleUrlAuthLoading:
      state.ThirdPartyIntegration.thirdPartyGoogleUrlAuthLoading,
    thirdPartyGoogleGenerateAccessTokenDataAPI:
      state.ThirdPartyIntegration.thirdPartyGoogleGenerateAccessTokenData,
  }));

  useEffect(() => {
    dispatch(thirdPartyGoogleUrlAuth());
  }, []);

  useEffect(() => {
    const urlParams = new URLSearchParams(window.location.search);
    const code = urlParams.get("code");
    if (code) {
      setExtractedCode(code);
    }
  }, []);

  useEffect(() => {
    if (!extractedCode) return;

    dispatch(
      thirdPartyGoogleGenerateAccessToken([
        {
          Code: extractedCode,
          Scope: "https://www.googleapis.com/auth/business.manage",
        },
      ])
    );
  }, [extractedCode]);

  useEffect(() => {
    if (isEmpty(thirdPartyGoogleGenerateAccessTokenDataAPI)) return;

    if (thirdPartyGoogleGenerateAccessTokenDataAPI.status === 200) {
      toast.success(thirdPartyGoogleGenerateAccessTokenDataAPI.message);
      setAccessTokenGenerated(true);
      setResponseMessage(thirdPartyGoogleGenerateAccessTokenDataAPI.message);
    } else {
      toast.error(
        thirdPartyGoogleGenerateAccessTokenDataAPI.message ||
          "Something went wrong while connecting Google"
      );
      setAccessTokenGenerated(false);
    }

    setExtractedCode(null);

    const { mainTopTab, activeMenu } = params;
    history.replace(`/settings/${mainTopTab}/${activeMenu}/google`);
  }, [thirdPartyGoogleGenerateAccessTokenDataAPI]);

  const handleConnect = () => {
    if (thirdPartyGoogleUrlAuthDataAPI?.url_auth) {
      window.location.href = thirdPartyGoogleUrlAuthDataAPI.url_auth;
    } else {
      toast.error("Google connection URL not available.");
    }
  };

  return (
    <Card className="p-2">
      <h5>Google Integration</h5>
      {thirdPartyGoogleUrlAuthLoading ? (
        <LoadingSpinner />
      ) : (
        <>
          {!accessTokenGenerated ? (
            <>
              <p>Connect your Google account to synchronise business tools.</p>
              {extractedCode ? (
                <p>Processing authorisation... Please wait.</p>
              ) : (
                <button
                  className="btn btn-primary mt-2"
                  onClick={handleConnect}
                  disabled={!thirdPartyGoogleUrlAuthDataAPI?.url_auth}
                >
                  Connect to Google
                </button>
              )}
            </>
          ) : (
            <>
              <p className="text-success fw-semibold">{responseMessage}</p>
              <button
                className="btn btn-outline-primary mt-2"
                onClick={handleConnect}
                disabled={!thirdPartyGoogleUrlAuthDataAPI?.url_auth}
              >
                Connect to Another Account
              </button>
            </>
          )}
        </>
      )}
    </Card>
  );
}
